export const pathRoutes = {
    OBJECT_ORGANIZATION: '/object-organization',
    INFORMATION: '/information',
    FINANCE_REPORT: '/finance-report',
    BONUSES_REPORT: '/bonuses-report',
    JACKPOT_REPORT: '/jackpot-report',
    BALANCE_REPORT: '/balance-report',
    EVENT_REPORT: '/event-report',
    JACKPOT: '/jackpot',
    JACKPOT_CREATE: '/jackpot/create',
    JACKPOT_EDIT: '/jackpot/edit/:id',
    TOURNAMENT_LIST: '/tournament/list',
    TOURNAMENT_CREATE: '/tournament/create',
    TOURNAMENT_EDIT: '/tournament/edit/:id',
    TOURNAMENT_STAT: '/tournament/stat/:id',
    LOTTERY_LIST: '/lottery/list',
    LOTTERY_CREATE: '/lottery/create',
    LOTTERY_EDIT: '/lottery/edit/:id',
    LOTTERY_STAT: '/lottery/stat/:id',
    LOTTERY_PRIZE: '/lottery/prize/:id',
    REFERRAL: '/traffic/referral',
    REFERRAL_PROMOCODE: '/traffic/referral/:promocode',
    GAMES_CREDIT: '/games/credit',
    HISTORY_CREDIT: '/history/credit',
    GAMES_PROVIDER_REPORT: '/games/provider-report',
    GAMES_SEARCH: '/games/games-search',
    PAYMENT_SYSTEM: '/payment-system/list',
    WITHDRAWALS: '/withdrawals',
    WITHDRAWALS_OPERATION: '/withdrawals/operation',
    REPLENISHMENT_GAMER_REPORT: '/replenishment/gamer-report',
    REPLENISHMENT_REPORT: '/replenishment/replenishment-report',
    REPLENISHMENT_GENERAL_REPORT: '/replenishment/general-report',
    REPLENISHMENT_TRANSACTION: '/replenishment/transaction',
    GAMER_REPORT: '/gamer/gamer-report',
    GAMER_LIST: '/gamer/list',
    GAMER_LIST_ID: '/gamer/list/:id',
    GAMER_REPORT_EVENT: '/gamer/list/report-event/:id',
    GAMER_REPORT_GAME: '/gamer/list/report-game/:id',
    BONUS: '/bonuses/bonus',
    BONUS_TEMPLATE: '/bonuses/select-template',
    BONUS_SETTINGS: '/bonuses/settings/:bonus/:id',
    PERSONAL_BONUS: '/bonuses/personal-bonus',
    PERSONAL_BONUS_CREATE: '/bonuses/personal-bonus/create',
    PRESENT_CONFIRMATION: '/present/confirmation',
    FREESPIN_GAME: '/freespin/game',
    FREESPIN_GAME_CREATE: '/freespin/game/create',
    FREESPIN_GAME_EDIT: '/freespin/game/edit/:id',
    FREESPIN_LIST: '/freespin/list',
    FREESPIN_ISSUE: '/freespin/issue',
    FREESPIN_VIEW: '/freespin/view',
    CASHIER_USERS: '/cashier/users',
    CASHIER_SHIFT: '/cashier/shift',
    CASHIER_DAILY: '/cashier/daily',
    CASHIER_DAILY_ID: '/cashier/daily/view/:id',
    CASHIER_GROUP: '/cashier/group',
    CASHIER_GROUP_ID: '/cashier/group/:id',
    SUPPORT: '/support',
    SECURITY_ADMIN_LIST: '/security/list/admin',
    SECURITY_ADMIN_VIEW: '/security/view/admin/:id',
    SECURITY_SIGNIN_HISTORY: '/security/history/signin',
    SECURITY_EVENT_HISTORY: '/security/history/event',
    SETTINGS_MESSANGER: '/settings/messanger',
    SETTINGS_MESSANGER_CREATE: '/settings/messanger/create',
    SETTINGS_MESSANGER_EDIT: '/settings/messanger/edit/:id',
    SETTINGS_EXCHANGE: '/settings/exchange-rates',
    SETTINGS_EXCHANGE_CREATE: '/settings/exchange-rates/create',
    SETTINGS_EXCHANGE_EDIT: '/settings/exchange-rates/edit/:id',
    KYC: '/kyc',
    KEYS: '/keys',
    PINSALE: '/pinsale',
    PINSALE_CREATE: '/pinsale/create',
    STATISTICS: '/statistics',
    CODE_COUNTRY: '/settings/code_country/list',
    CODE_COUNTRY_CREATE: '/settings/code_country/create',
    CURRENCY_LIST: '/settings/currency/list',
    CURRENCY_CREATE: '/settings/currency/create',
    RULES_LIST: '/settings/rules/list',
    RULES_CREATE: '/settings/rules/create',
    DICTIONARY_LIST: '/settings/dictionary/list',
    DICTIONARY_CREATE: '/settings/dictionary/create',
    CASHBACK: '/cashback',
    GAMES_LIST: '/games/list',
    GAMES_CREATE: '/games/create',
    GAMES_EDIT: '/games/edit/:id',
    PROVIDERS_LIST: '/providers/list',
    PROVIDERS_CREATE: '/providers/create',
    PROVIDERS_EDIT: '/providers/edit/:id',
    MAILING_LIST: '/mailing/list/',
    MAILING_VIEW: '/mailing/view/:id'
}